import {
  addPassiveEventListener as oe,
  buildSvg as ae,
  detectSwipe as d,
  DIRECTIONS as c
} from "../../util/dom-utils.js";
import { createCloseButton as i } from "../../util/component-utils.js";
import { isTransparent as ie, toRgba as ne } from "../../util/color-utils.js";
import FullScreenMessage from "../models/full-screen-message.js";
import HtmlMessage from "../models/html-message.js";
import InAppMessage from "../models/in-app-message.js";
import ModalMessage from "../models/modal-message.js";
import SlideUpMessage from "../models/slide-up-message.js";
import { logInAppMessageClick } from "../log-in-app-message-click.js";
import { _handleBrazeAction as m } from "../../Core/handle-braze-action.js";
import ct from "./html-message-to-html.js";
import me from "./modal-utils.js";
import r from "../../../shared-lib/braze-shared-lib.js";
export default function ce(e, o, a, s, t, n, l) {
  if (((e.Le = document.activeElement), e instanceof HtmlMessage))
    return ct(e, o, a, t, n, l);
  const b = (function(e, o, a, s, t, n) {
    const c = document.createElement("div");
    (c.className = "ab-in-app-message ab-start-hidden ab-background"),
      n && (c.style.zIndex = n + 1),
      e.Ie() &&
        ((c.className += " ab-modal-interactions"),
        c.setAttribute("tabindex", "-1")),
      e.sn() ||
        ((c.style.color = ne(e.textColor)),
        (c.style.backgroundColor = ne(e.backgroundColor)),
        ie(e.backgroundColor) && (c.className += " ab-no-shadow"));
    const d = () => {
        -1 !== c.className.indexOf("ab-start-hidden") &&
          ((c.className = c.className.replace("ab-start-hidden", "")),
          document.querySelectorAll(".ab-iam-img-loading").length > 0
            ? s(
                `Cannot show in-app message ${e.message} because another message is being shown.`,
                InAppMessage.Ge.Ee
              )
            : a(c));
      },
      l = () => {
        const e = document.querySelectorAll(".ab-iam-root");
        e && e.length > 0 && (e[0].classList.remove("ab-iam-img-loading"), d());
      };
    e.imageStyle === InAppMessage.ImageStyle.GRAPHIC &&
      (c.className += " graphic"),
      e.orientation === InAppMessage.Orientation.LANDSCAPE &&
        (c.className += " landscape"),
      0 === e.buttons.length &&
        (e.clickAction !== InAppMessage.ClickAction.NONE &&
          (c.className += " ab-clickable"),
        (c.onclick = a => (
          e.on(c, () => {
            logInAppMessageClick(e),
              e.clickAction === InAppMessage.ClickAction.URI
                ? m(
                    e.uri,
                    a,
                    t || e.openTarget === InAppMessage.OpenTarget.BLANK
                  )
                : e.clickAction === InAppMessage.ClickAction.NEWS_FEED && o();
          }),
          a.stopPropagation(),
          !1
        )));
    const b = i(
      "Close Message",
      e.sn() ? void 0 : ne(e.closeButtonColor),
      () => {
        e.on(c);
      }
    );
    c.appendChild(b), n && (b.style.zIndex = n + 2);
    const u = document.createElement("div");
    u.className = "ab-message-text";
    const p = (e.messageAlignment || e.He).toLowerCase();
    u.className += " " + p + "-aligned";
    let f = !1;
    const g = document.createElement("div");
    if (((g.className = "ab-image-area"), e.imageUrl)) {
      if (e.cropType === InAppMessage.CropType.CENTER_CROP) {
        const o = document.createElement("span");
        (o.className = "ab-center-cropped-img"),
          (o.style.backgroundImage = "url(" + e.imageUrl + ")"),
          o.setAttribute("role", "img"),
          o.setAttribute("aria-label", "Modal Image"),
          e.Je(o),
          g.appendChild(o);
      } else {
        const o = document.createElement("img");
        if (
          (o.setAttribute("src", e.imageUrl),
          e.Je(o),
          0 === document.querySelectorAll(".ab-iam-img-loading").length)
        ) {
          f = !0;
          const e = document.querySelectorAll(".ab-iam-root");
          e && e.length > 0 && e[0].classList.add("ab-iam-img-loading"),
            (o.onload = l);
        }
        setTimeout(d, 1e3), g.appendChild(o);
      }
      c.appendChild(g), (u.className += " ab-with-image");
    } else if (e.icon) {
      g.className += " ab-icon-area";
      const o = document.createElement("span");
      (o.className = "ab-icon"),
        e.sn() ||
          ((o.style.backgroundColor = ne(e.iconBackgroundColor)),
          (o.style.color = ne(e.iconColor)));
      const a = document.createElement("i");
      (a.className = "fa"),
        a.appendChild(document.createTextNode(e.icon)),
        a.setAttribute("aria-hidden", !0),
        o.appendChild(a),
        g.appendChild(o),
        c.appendChild(g),
        (u.className += " ab-with-icon");
    }
    if ((oe(u, "touchstart", function() {}), e.header && e.header.length > 0)) {
      const o = document.createElement("h1");
      (o.className = "ab-message-header"), (e.Ke = r.it.nt()), (o.id = e.Ke);
      const a = (
        e.headerAlignment || InAppMessage.TextAlignment.CENTER
      ).toLowerCase();
      (o.className += " " + a + "-aligned"),
        e.sn() || (o.style.color = ne(e.headerTextColor)),
        o.appendChild(document.createTextNode(e.header)),
        u.appendChild(o);
    }
    return u.appendChild(e.Oe()), c.appendChild(u), f || d(), (e.mn = c), c;
  })(e, o, a, s, t, n);
  if (e instanceof FullScreenMessage || e instanceof ModalMessage) {
    const a = e instanceof FullScreenMessage ? "ab-fullscreen" : "ab-modal";
    (b.className += ` ${a} ab-centered`),
      me.Pe(e, o, b, t),
      me.Qe(b),
      me.Ve(e.Ke, b);
  } else if (e instanceof SlideUpMessage) {
    b.className += " ab-slideup";
    const o = b.getElementsByClassName("ab-close-button")[0];
    if (null != o) {
      const a = ae(
        "0 0 11.38 19.44",
        "M11.38 9.72l-9.33 9.72L0 17.3l7.27-7.58L0 2.14 2.05 0l9.33 9.72z",
        e.sn() ? void 0 : ne(e.closeButtonColor)
      );
      a.setAttribute("class", "ab-chevron"), o.appendChild(a);
    }
    let a, s;
    d(b, c.ot, e => {
      (b.className += " ab-swiped-left"), o.onclick(e);
    }),
      d(b, c.et, e => {
        (b.className += " ab-swiped-right"), o.onclick(e);
      }),
      e.slideFrom === InAppMessage.SlideFrom.TOP
        ? ((a = c.We), (s = " ab-swiped-up"))
        : ((a = c.Xe), (s = " ab-swiped-down")),
      d(b, a, e => {
        (b.className += s), o.onclick(e);
      });
  }
  return b;
}
